import { z } from "zod"
import { OrderInformationSchema } from "../orderInformation"

export const AmphoraIntegrationResponseDataSchema = z.object({
  accessId: z.string().optional(),
  useWhatsapp: z.boolean().optional(),
  useEmail: z.boolean().optional(),
  hasWhatsappLogisticsCampaign: z.boolean().optional(),
})

export const AmphoraGetOrderInfoResponseData = OrderInformationSchema

export const AmphoraMessageWebhookResponseDataSchema = z.object({
  processed: z.boolean(),
  endUserContact: z.boolean(),
})
